/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2112
 */

"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
